import { FormOutlined } from "@ant-design/icons";
import { Space, Form } from "antd";
import { ColumnsType } from "antd/lib/table";
import { AddProductModal, EditProductModal, MenuPage } from "components";
import React, { useState } from "react";
import { api } from "services/api";
import { DataModule } from "types";
import "./style.scss";

export const ManageProducts: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [productStatus, setProductStatus] = useState<boolean>(false);
	const [productIsHighlight, setProductIsHighlight] = useState<boolean>(false);
	const [currentProductInfo, setCurrentProductInfo] = useState<any>();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { product },
			},
		} = await api.get(`/products/${id}`);
		setCurrentProductInfo(product);
	};

	const columns: ColumnsType<DataModule> = [
		{
			title: "Título do produto",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => (
				<p style={{ margin: 0 }}>
					{status === "publish" ? "Publicado" : "Desativado"}
				</p>
			),
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.products;
	}

	return (
		<div className="m-product">
			<AddProductModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productIsHighlight={productIsHighlight}
				setProductIsHighlight={setProductIsHighlight}
				onCreated={handleRefresh}
			/>
			<EditProductModal
				form={editForm}
				setIsOpen={setIsOpenEdit}
				isOpen={isOpenEdit}
				currentProductInfo={currentProductInfo}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productIsHighlight={productIsHighlight}
				setProductIsHighlight={setProductIsHighlight}
				onUpdated={handleRefresh}
			/>

			<MenuPage 
				title="Produtos" 
				tableColumns={columns} 
				sourceDataUrl={'/products'}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Produto" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por título ou descrição"
			/>
		</div>
	);
};
